import type { ComponentProps } from 'react';
import { OwcHeaderRow } from '@one/react';

export type PocHeaderRowProps = ComponentProps<typeof OwcHeaderRow>;

export const PocHeaderRow: React.FC<PocHeaderRowProps> = (props) => <OwcHeaderRow {...props} />;
